import * as React from 'react';

import * as styles from './styles.css';

export interface IPageDesktopProps {
  sidebar: React.ReactNode;
}

export const PageDesktop: React.FC<React.PropsWithChildren<IPageDesktopProps>> = ({ children, sidebar }) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']}>
        <div className={styles['sidebar']}>{sidebar}</div>
        <div className={styles['content']}>{children}</div>
      </div>
    </div>
  );
};

PageDesktop.displayName = 'PageDesktop';
